export { default } from './LogoDirecte';
